import { render, staticRenderFns } from "./WatchersStat.vue?vue&type=template&id=1fecb2e1&scoped=true&"
import script from "./WatchersStat.vue?vue&type=script&lang=js&"
export * from "./WatchersStat.vue?vue&type=script&lang=js&"
import style0 from "./WatchersStat.vue?vue&type=style&index=0&id=1fecb2e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecb2e1",
  null
  
)

export default component.exports